export default __webpack_public_path__ + "static/david-jones-group-55cdace70eaf630da99d0b294935a162.png";